package io.horion.cv.pages.dashboard

import androidx.compose.runtime.*
import io.horion.cv.components.auth.RequireAuth
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.layouts.AppResponsiveLayout
import io.horion.cv.models.KanbanCard
import io.horion.cv.models.KanbanColumn
import io.horion.cv.styles.CandidaturesTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event

private const val ATTR_CARD_MENU = "data-card-menu"

@OptIn(DelicateApi::class)
@Page("candidatures")
@Composable
fun CandidaturesPage() = RequireAuth {

    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
//    val isMobile = breakpoint <= Breakpoint.MD

    var columns by remember {
        mutableStateOf(
            listOf(
                KanbanColumn("Mes offres"),
                KanbanColumn("Candidature envoyée"),
                KanbanColumn("Entretien"),
                KanbanColumn("Proposition d'embauche"),
                KanbanColumn("Candidature rejetée"),
                KanbanColumn("Embauché(e)"),
            )
        )
    }

    var openMenuCardId by remember { mutableStateOf<String?>(null) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { event ->
            val target = event.target as? HTMLElement
            if (target?.closest("[$ATTR_CARD_MENU]") == null) openMenuCardId = null
        }
        document.addEventListener("click", listener, true)
        onDispose { document.removeEventListener("click", listener, true) }
    }

    AppResponsiveLayout(activeLabel = "Candidatures") {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .gap(50.px)
        ) {
            SpanText(
                text = "Candidatures",
                modifier = CandidaturesTextStyle.toModifier()
//                    .fontSize(if (isMobile) 20.px else 26.px)
                    .fontFamily(UBUNTU)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Colors.DarkBlue)
            )

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .overflow(Overflow.Auto)
            ) {
                Column(modifier = Modifier.fillMaxWidth()) {

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(50.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        columns.forEachIndexed { colIndex, column ->
                            Row(
                                modifier = Modifier
                                    .width(260.px)
                                    .padding(leftRight = 16.px, topBottom = 12.px),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                SpanText(
                                    text = column.label,
                                    modifier = Modifier
                                        .fontFamily(INTER)
                                        .fontSize(14.px)
                                        .fontWeight(FontWeight.SemiBold)
                                        .color(Colors.Black)
                                )
                                Box(
                                    modifier = Modifier
                                        .size(28.px)
                                        .border(1.px, LineStyle.Solid, Colors.lineBorder)
                                        .borderRadius(6.px)
                                        .cursor(Cursor.Pointer)
                                        .onClick {
                                            val newCard = KanbanCard(
                                                id = "new_${window.performance.now().toLong()}",
                                                jobTitle = "",
                                                company = "",
                                                date = "Modifié il y a quelques secondes",
                                                isEditing = true
                                            )
                                            columns = columns.toMutableList().also {
                                                it[colIndex] = column.copy(cards = listOf(newCard) + column.cards)
                                            }
                                        },
                                    contentAlignment = Alignment.Center
                                ) {
                                    Image(
                                        src = "/plus.svg",
                                        description = "Ajouter",
                                        modifier = Modifier.size(14.px)
                                    )
                                }
                            }
                        }
                    }
                    Row(
                        modifier = Modifier.gap(16.px).minHeight(80.vh),
                        verticalAlignment = Alignment.Top
                    ) {
                        columns.forEachIndexed { colIndex, column ->
                            KanbanColumnBody(
                                column = column,
                                openMenuCardId = openMenuCardId,
                                onMenuOpen = { cardId -> openMenuCardId = cardId },
                                onCardUpdate = { updatedCard ->
                                    columns = columns.toMutableList().also { cols ->
                                        cols[colIndex] = column.copy(
                                            cards = column.cards.map { if (it.id == updatedCard.id) updatedCard else it }
                                        )
                                    }
                                },
                                onCardDelete = { cardId ->
                                    columns = columns.toMutableList().also { cols ->
                                        cols[colIndex] = column.copy(
                                            cards = column.cards.filter { it.id != cardId }
                                        )
                                    }
                                    openMenuCardId = null
                                }
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun KanbanColumnBody(
    column: KanbanColumn,
    openMenuCardId: String?,
    onMenuOpen: (String?) -> Unit,
    onCardUpdate: (KanbanCard) -> Unit,
    onCardDelete: (String) -> Unit
) {
    Column(
        modifier = Modifier
            .width(260.px)
            .minHeight(80.vh)
            .backgroundColor(Colors.White)
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .padding(topBottom = 10.px, leftRight = 10.px)
            .gap(10.px)
    ) {
        column.cards.forEach { card ->
            KanbanCardView(
                card = card,
                isMenuOpen = openMenuCardId == card.id,
                onMenuToggle = { onMenuOpen(if (openMenuCardId == card.id) null else card.id) },
                onTitleChange = { onCardUpdate(card.copy(jobTitle = it, isEditing = true)) },
                onEditDone = { onCardUpdate(card.copy(isEditing = false)) },
                onDelete = { onCardDelete(card.id) }
            )
        }
    }
}

@Composable
fun KanbanCardView(
    card: KanbanCard,
    isMenuOpen: Boolean,
    onMenuToggle: () -> Unit,
    onTitleChange: (String) -> Unit,
    onEditDone: () -> Unit,
    onDelete: () -> Unit
) {
    Div(
        attrs = Modifier
            .position(Position.Relative)
            .toAttrs { attr(ATTR_CARD_MENU, "true") }
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Colors.White)
                .borderRadius(8.px)
                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                .padding(topBottom = 10.px, leftRight = 12.px)
                .position(Position.Relative)
        ) {
            Column(modifier = Modifier.fillMaxWidth().gap(4.px)) {

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    if (card.isEditing) {
                        Input(
                            type = InputType.Text,
                            attrs = Modifier
                                .weight(1f)
                                .height(28.px)
                                .border(0.px, LineStyle.None, Colors.White)
                                .borderBottom(1.px, LineStyle.Solid, Colors.Blue)
                                .backgroundColor(Colors.White)
                                .padding(leftRight = 0.px)
                                .fontSize(13.px)
                                .fontFamily(INTER)
                                .color(Colors.Black)
                                .toAttrs {
                                    placeholder("Poste")
                                    value(card.jobTitle)
                                    onInput { onTitleChange(it.value) }
                                    onBlur { onEditDone() }
                                    ref { element ->
                                        element.focus()
                                        onDispose {}
                                    }
                                }
                        )
                    } else {
                        SpanText(
                            text = card.jobTitle.ifEmpty { "Sans titre" },
                            modifier = Modifier
                                .fontFamily(INTER).fontSize(13.px)
                                .fontWeight(FontWeight.Medium).color(Colors.Black)
                        )
                    }

                    Box(
                        modifier = Modifier
                            .size(28.px)
                            .borderRadius(4.px)
                            .cursor(Cursor.Pointer)
                            .onClick { onMenuToggle() },
                        contentAlignment = Alignment.Center
                    ) {
                        Image(src = "/dots-vertical.svg", description = "Options", modifier = Modifier.size(16.px))
                    }
                }

                if (card.date.isNotEmpty()) {
                    SpanText(
                        text = card.date,
                        modifier = Modifier.fontFamily(INTER).fontSize(11.px).color(Colors.Graytext)
                    )
                }
            }

            if (isMenuOpen) {
                Column(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(36.px)
                        .right(0.px)
                        .width(180.px)
                        .backgroundColor(Colors.White)
                        .border(1.px, LineStyle.Solid, Colors.lineBorder)
                        .borderRadius(10.px)
                        .padding(topBottom = 6.px)
                        .zIndex(200)
                        .boxShadow(offsetX = 0.px, offsetY = 4.px, blurRadius = 12.px, color = Colors.HalfBlack)
                ) {
                    CardMenuItem("/edit-icon.svg",   "Modifier")  { /* naviguer vers édition */ }
                    CardMenuItem("/price-tag1.svg", "Renommer")  { onTitleChange(card.jobTitle); /* activer édition */ }
                    CardMenuItem("/delete-bin.svg",  "Supprimer") { onDelete() }
                }
            }
        }
    }
}

@Composable
private fun CardMenuItem(
    icon: String,
    label: String,
    onClick: () -> Unit
) {
    var hovered by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(40.px)
            .padding(leftRight = 16.px)
            .backgroundColor(if (hovered) Colors.PriceGray else Colors.White)
            .cursor(Cursor.Pointer)
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { onClick() }
            .gap(12.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            src = icon,
            description = label,
            modifier = Modifier.size(18.px)
        )
        SpanText(
            text = label,
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(14.px)
                .color(Colors.Black)
        )
    }
}

